import React from "react";
import { H2sPopupContainer } from "./popupTableHelper";
import { displayedIndicator, getColor } from "./popupHelper";
import ReactDOMServer from "react-dom/server";
import { getH2sDataColor } from "../table/tableHelper";
import { EventsPluieApi } from "../../api";

export const getInfoH2s = async (feature) => {
  // Get H2S indicator name
  const indicatorModule: string | null =
    window.sessionStorage.getItem('h2s_indicator');
  let content = document.createElement('div');
  let attributes = feature.graphic.attributes;
  const indicator = getH2sDataColor();
  const categoriesOnly =
    attributes[indicator] !== 'NOIR' && attributes[indicator] !== 'GRIS';
  const dateRemontee = categoriesOnly
    ? attributes['RecordDate'+indicator.slice(5)]
    : 'Pas de télégestion';

  const povInfo = EventsPluieApi.getInstallPov(attributes.Code);
  const [povValue] = await Promise.allSettled([povInfo]);

  let idPov = 'NR';
  if (povValue.status === 'fulfilled' && povValue.value) {
    idPov = povValue.value.data;
  }

  const tableElements = {
    'Boon&Lister (mg/l)': [
      getColor(attributes.ColorBoonLister),
      attributes.ValueBoonLister,
    ],
    'Tps séjour cana(h)': [
      getColor(attributes.ColorSejourCana),
      attributes.ValueSejourCana,
    ],
    'Tps séjour PR(dem/j)': [
      getColor(attributes.ColorSejourPR),
      attributes.ValueSejourPR,
    ],
    'Vit autocurage(m/s)': [
      getColor(attributes.ColorAutocurage),
      attributes.ValueAutocurage,
    ],
    Terrain: [getColor(attributes.ColorTerrain), attributes.ValueTerrain],
    POV: [null, idPov],
  };

  content.innerHTML = ReactDOMServer.renderToString(
    <H2sPopupContainer
      title={attributes?.Description}
      dateRemontee={dateRemontee}
      tableElements={tableElements}
      indicator={displayedIndicator(indicatorModule!)}
    />
  );
  return content;
};